import React from "react";
import { formatCareerEarnings } from "@/utils/race-cards";

/**
 * Component to display extra horse details (weight, form, trainer, jockey, career earnings, sex)
 * @param {Object} entry - The horse entry data
 * @returns {JSX.Element} - The extra details component
 */
export default function HorseExtraDetails({ entry }) {
  if (!entry) return null;

  // Format weight to show with 'kg' unit
  const formatWeight = (weight) => {
    if (!weight) return "N/A";
    return `${weight}kg`;
  };

  // Format form to be more readable (show as string of digits)
  const formatForm = (form) => {
    if (!form) return "N/A";
    return form.toString();
  };

  return (
    <div className="extra-details-container mb-1 text-[10px] text-gray-600">
      <div className="flex justify-start gap-x-5">
        <div className="flex flex-col gap-y-1">
          {/* Weight */}
          <div className="flex items-start">
            <span className="font-medium mr-1 text-gray-500">W:</span>
            <span>{formatWeight(entry.weight)}</span>
          </div>
          {/* Form */}
          <div className="flex items-start">
            <span className="font-medium mr-1 text-gray-500">F:</span>
            <span className="font-mono">{formatForm(entry.form)}</span>
          </div>
        </div>
        <div className="flex flex-col flex-1 gap-y-1">
          {/* Jockey */}
          <div className="flex items-start">
            <span className="font-medium mr-1 text-gray-500">J:</span>
            <span className="truncate" title={entry.jockey || "N/A"}>
              {entry.jockey || "N/A"}
            </span>
          </div>
          {/* Trainer */}
          <div className="flex items-start">
            <span className="font-medium mr-1 text-gray-500">T:</span>
            <span className="truncate" title={entry.trainer || "N/A"}>
              {entry.trainer || "N/A"}
            </span>
          </div>
        </div>
        <div className="flex flex-col items-end gap-x-4 gap-y-1">
          {/* Career earnings (the horse's, not the race's prize money) */}
          <div className="flex items-start">
            <span className="font-medium mr-1 text-gray-500 text-nowrap">
              Career:
            </span>
            <span>{formatCareerEarnings(entry.prizeMoney)}</span>
          </div>
          <div className="flex items-start">
            <span className="font-medium mr-1 text-gray-500">Gender:</span>
            <span>{entry.sex || "N/A"}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
